import { render, staticRenderFns } from "./ProductInfoPanel.vue?vue&type=template&id=be1ad66e&lang=pug&"
import script from "./ProductInfoPanel.vue?vue&type=script&lang=js&"
export * from "./ProductInfoPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProductInfoPanel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports